
import { addToChainAfter, createHandlerChainRunner, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import { chain,RemoveAllFilters } from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearAllProductFilters";
import { CustomProductFilters } from "@tSurya/Handlers/ProductList/AddProductAvailibility";

type HandlerType = HandlerWithResult<
    {
        removeAll?: true;
    },
    CustomProductFilters
>;

export const RemoveProductAvailibility:  HandlerType = props => {
    props.result.minimumPrice = undefined;
};



addToChainAfter(chain,RemoveAllFilters,RemoveProductAvailibility);